import { BellRing, X } from "lucide-react";

interface NewOrderToastProps {
  title: string;
  subtitle: string;
  actionLabel: string;
  closeLabel: string;
  onView: () => void;
  onClose: () => void;
}

/** Rich toast for a newly routed order — offers a one-click jump. */
export function NewOrderToast({
  title,
  subtitle,
  actionLabel,
  closeLabel,
  onView,
  onClose,
}: NewOrderToastProps) {
  return (
    <div className="orders-new-toast" role="status">
      <span className="orders-new-toast__icon" aria-hidden>
        <BellRing className="h-4 w-4" />
      </span>
      <div className="min-w-0 flex-1">
        <p className="orders-new-toast__title">{title}</p>
        <p className="orders-new-toast__meta truncate">{subtitle}</p>
      </div>
      <button type="button" className="orders-new-toast__action" onClick={onView}>
        {actionLabel}
      </button>
      <button
        type="button"
        className="orders-new-toast__close"
        onClick={onClose}
        aria-label={closeLabel}
      >
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  );
}
